import { render, staticRenderFns } from "./InstanceItemMenu.vue?vue&type=template&id=ca1cc9c6&scoped=true"
import script from "./InstanceItemMenu.vue?vue&type=script&lang=js"
export * from "./InstanceItemMenu.vue?vue&type=script&lang=js"
import style0 from "./InstanceItemMenu.vue?vue&type=style&index=0&id=ca1cc9c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1cc9c6",
  null
  
)

export default component.exports